import styled from 'styled-components';
import { Space } from 'antd';
import { I18n } from 'react-redux-i18n';

import Button from 'components/Button';
import NotebookContentComponent from 'components/Notebook/NotebookContent';
import TitleComponent from '../TitleComponent';
import get from 'lodash/get';
import React from 'react';

const NextMarketNoteBooksContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background-color: ${(props) => props.theme.colors['white']};
  border-radius: 10px;
  min-height: 200px;

  .calendarNextSurveysContainer {
    margin-top: 20px;
    display: grid;
    grid-template-columns: auto;
    grid-gap: 10px;
    background-color: transparent;
    height: 100%;
  }

  .empty {
    justify-content: center;
    align-items: center;
    color: #979797;
    font-family: ${(props) => props.theme.fonts.oswald};
  }
`;

const NextMarketNoteBooks = ({ data }) => {
  let contentClasses = ['calendarNextSurveysContainer'];
  if (data && data.length === 0) {
    contentClasses.push('empty');
  }
  return (
    <NextMarketNoteBooksContainer>
      <Space size={20} className="titleContainer">
        <a
          href="https://wineservices-production.s3.amazonaws.com/static/WS_Markets.pdf"
          target="_blank"
          rel="noreferrer"
        >
          <Button type="round" icon="download" />
        </a>
        <TitleComponent>
          <p>{I18n.t('dashboard.calendarNextSurveysTitle').toUpperCase()}</p>
        </TitleComponent>
      </Space>
      <div className={contentClasses.join(' ')}>
        {data &&
          data.map((trip, index) => (
            <NotebookContentComponent
              key={index}
              name={get(trip, 'city')}
              network={get(trip, 'networkCode')}
              date={get(trip, 'date')}
              showCalendarIcon={true}
            />
          ))}
        {(!data || data.length === 0) && (
          <span>{I18n.t('dashboard.no_market_planned')}</span>
        )}
      </div>
    </NextMarketNoteBooksContainer>
  );
};

export default NextMarketNoteBooks;
